import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { SlideRating as SlideRating$2, Label, Container, Bar, Progress, Rating } from './style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["title", "rating", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getProgress = function getProgress(rating) {
  if (!rating || typeof rating === 'string') return {
    width: 0
  };
  var progress = rating / 5 * 100;
  return {
    width: "".concat(progress, "%")
  };
};
var getStringRating = function getStringRating(rating) {
  var ratingString = rating.toString();
  if (ratingString.length === 1) {
    ratingString += ',0';
  }
  if (ratingString.indexOf('.') > 0) {
    ratingString = ratingString.replace('.', ',');
  }
  return ratingString;
};
var SlideRating = function SlideRating(_ref) {
  var title = _ref.title,
    rating = _ref.rating,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (rating < 0 || rating > 5) {
    return null;
  }
  return /*#__PURE__*/jsxs(SlideRating$2, _objectSpread(_objectSpread({
    className: className
  }, rest), {}, {
    children: [title && /*#__PURE__*/jsx(Label, {
      children: title
    }), /*#__PURE__*/jsxs(Container, {
      children: [/*#__PURE__*/jsx(Bar, {
        children: /*#__PURE__*/jsx(Progress, {
          style: getProgress(rating)
        })
      }), /*#__PURE__*/jsx(Rating, {
        children: getStringRating(Math.round(rating * 10) / 10)
      })]
    })]
  }));
};
SlideRating.defaultProps = {
  title: null,
  className: null
};
var SlideRating$1 = SlideRating;

export { SlideRating$1 as default, getProgress, getStringRating };
//# sourceMappingURL=SlideRating.js.map
